import React, { useState, useMemo } from 'react';
import { Menu } from 'antd';
import Icon from 'component/icon';
import FavoritesIcon from './favoritesIcon';

const TopMenu = (props) => {
    const {
        pages,
        setIsMenuOpen,
        currentRouteName,
        onClickMenu,
        logo,
        myFavorites,
        langConfig
    } = props;
    const [openKey, setOpenKey] = useState('');

    const dropDownMenuContent = useMemo(() => {
        const favoriteMenus = {
            key: 'favorites',
            label: (
                <>
                    <span>{langConfig?.favorite || '最愛'}</span>
                    <Icon
                        name="expand_more"
                        size={20}
                        className={openKey === 'favorites' ? 'rotate-180 ml-2' : 'ml-2'}
                    />
                </>
            ),
            children: []
        };
        const addFavoritePages = (page) => {
            if (myFavorites.favoritePages.includes(page.key)) {
                favoriteMenus.children.push({
                    ...page,
                    key: `favorites-${page.key}`,
                    onClick: () => onClickMenu?.(page.key)
                });
            }
        };
        const dropDownMenus = pages?.map((pageGroup) => {
            const { path, name, children } = pageGroup || {};
            return {
                key: path || (children?.length ? name : ''),
                label: (
                    <>
                        <span>{name}</span>
                        {!!children?.length && (
                            <Icon
                                name="expand_more"
                                size={20}
                                className={openKey === (path || name) ? 'rotate-180 ml-2' : 'ml-2'}
                            />
                        )}
                    </>
                ),
                children: children?.map((page) => {
                    const pageObj = {
                        key: page.path || (page.children?.length ? page.name : ''),
                        label: (
                            <div className="flex justify-between items-center">
                                <span>{page.name}</span>
                                {!page.children?.length && (
                                    <FavoritesIcon myFavorites={myFavorites} page={page.path} />
                                )}
                            </div>
                        ),
                        children: page.children?.map((subPage) => {
                            const subPageObj = {
                                key: subPage.path || subPage.name,
                                label: (
                                    <div className="flex justify-between items-center">
                                        <span>{subPage.name}</span>
                                        <FavoritesIcon
                                            myFavorites={myFavorites}
                                            page={subPage.path}
                                        />
                                    </div>
                                ),
                                icon: subPage.icon,
                                className: 'menu-layout'
                            };
                            addFavoritePages(subPageObj);
                            return subPageObj;
                        }),
                        icon: page.icon,
                        className: 'menu-layout'
                    };
                    addFavoritePages(pageObj);
                    return pageObj;
                })
            };
        });
        if (myFavorites.open && favoriteMenus.children.length) {
            dropDownMenus.push(favoriteMenus);
        }
        return (
            <Menu
                mode="horizontal"
                items={dropDownMenus}
                onClick={({ key }) => {
                    if (!key.includes('favorites-')) {
                        onClickMenu?.(key);
                    }
                }}
                selectedKeys={[currentRouteName]}
                className="bg-menu w-fit border-b border-b-transparent"
                onOpenChange={(openKeys) => setOpenKey(openKeys?.[openKeys.length - 1])}
            />
        );
    }, [langConfig?.favorite, openKey, pages, myFavorites, currentRouteName, onClickMenu]);

    return (
        <div className="flex w-screen">
            <div className="w-[160px] px-4 flex items-center gap-4 bg-logo text-menu">
                {logo}
                <Icon
                    name="keyboard_double_arrow_up"
                    size={24}
                    onClick={() => setIsMenuOpen(false)}
                    className="cursor-pointer text-[#FDD12E]"
                />
            </div>
            <div className="w-[calc(100%_-_160px)] overflow-auto hidden-scrollbar">
                {dropDownMenuContent}
            </div>
        </div>
    );
};

export default TopMenu;
